import { MdStar, MdStarBorder } from 'react-icons/md';
import { Button, Icon } from '@nbirl/nbi-common-ui-libs';

import { useFolderTree } from '../../folders/context';
import { useFavouritesCountQuery, useToggleFavourite } from '../queries';

type FavouriteToggleProps = {
  isFolder: boolean;
  id: string;
  isFavorite?: boolean;
  onChange: () => void;
};

export const FavouriteToggle = ({
  isFolder,
  id,
  isFavorite,
  onChange,
}: FavouriteToggleProps) => {
  const { refetch: refetchFolderTree } = useFolderTree();
  const { refetch: refetchFavouritesCount } = useFavouritesCountQuery();
  const toggleFavouriteMutation = useToggleFavourite();

  const handleFavouriteToggle = () => {
    toggleFavouriteMutation.mutate(
      { id, isFolder },
      {
        onSuccess: () => {
          onChange();
          refetchFolderTree();
          refetchFavouritesCount();
        },
      }
    );
  };

  return (
    <Button
      variant="ghost"
      aria-label={`${isFavorite ? 'Unfavourite' : 'Favourite'} ${
        isFolder ? 'folder' : 'document'
      }`}
      size="sm"
      onClick={handleFavouriteToggle}
      onlyIcon
    >
      <Icon size="20" icon={isFavorite ? <MdStar /> : <MdStarBorder />} />
    </Button>
  );
};
